import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import { SearchFilterModel } from '@app/search/components/model/search-filter.model';
import {SearchResultsModel} from "@app/search/components/model/search-results.model";
import {SearchResultModel} from "@app/search/components/model/search-result.model";
import * as _ from "lodash";

@Component({
  templateUrl: './search-suggestions.component.html',
  styleUrls: ['search-suggestions.component.scss'],
  selector: 'search-suggestions'
})
export class SearchSuggestionsComponent implements OnInit {

  @Input() set resultsObj(results: SearchResultsModel) {
    this.results = results;
    if (this.results) {
      this.results.results = _.sortBy(results.results, 'type');
    }
  }
  @Input() loader = false;
  @Input() filters: SearchFilterModel[];
  @Output() filterSelected = new EventEmitter<SearchFilterModel>();

  results: SearchResultsModel;

  constructor(
  ) {
  }

  ngOnInit() {
  }

  onSelectFilter(filter: SearchFilterModel) {
    this.filterSelected.emit(filter);
  }
}
